import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createMinutes } from '../api/minutesApi'
import type { MinutesCreateRequest } from '../types'

/**
 * Tutanak oluşturma (Kaydet=taslak / Yayınla) mutasyonu (039). Yalnız toplantı + katılımcı create'i kapsar;
 * dokümanlar create başarıyla döndükten sonra ayrıca yüklenir (pending-first, best-effort — çağıran
 * orkestrasyonu). Başarıda Toplantılar ekranının beslendiği listeler geçersizleştirilir: yayınlanan kayıt grup
 * kartına/listesine, taslak ise <b>Taslaklar</b> kartına/listesine düşer.
 */
export function useCreateMinutes() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: MinutesCreateRequest) => createMinutes(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['meeting-groups'] })
      qc.invalidateQueries({ queryKey: ['draft-meetings'] })
      qc.invalidateQueries({ queryKey: ['group-meetings'] })
    },
  })
}
